import React from "react";
import Clinic from "../../../places/pages/Clinique/Clinic";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";

export default function AssistantClinicsPage() {
  return <Clinic LayoutComponent={AppLayoutAssistant} />;
}
